import { useLocation } from "react-router";
import React, { useEffect } from "react";

export default function AppLayout({ children }: React.PropsWithChildren<any>) {
  return (
    <div className="flex flex-row h-[100dvh]">
      <div className="h-[100dvh] flex flex-col grow">
        <div className="grow flex flex-row overflow-hidden">
          <div className="grow flex flex-col overflow-auto">{children}</div>
        </div>
      </div>
    </div>
  );
}
